import algoliasearch from 'algoliasearch'

const client = algoliasearch('DN60UERLGS', '5422850e357d7fa7dc1d8d85f9201e44');



export default client
